<template>
    <ErrorMessage v-slot="{ message }">
        <span role="alert">{{ localize(message) }}</span>
    </ErrorMessage>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { ErrorMessage } from 'vee-validate';
export default {
    components: { ErrorMessage },
    setup() {
        const { t } = useI18n();
        const localize = (message) => {
            return t(message)
        }

        return { localize }
    }
}


</script>